import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Image, Platform, StyleSheet, Text, View } from 'react-native';

const WEB_APP_HOST = 'app.repaschallenge.ch';

export function useDesktopWeb() {
  const [visible, setVisible] = useState(() => {
    if (Platform.OS !== 'web' || typeof window === 'undefined') return false;
    return window.matchMedia('(min-width: 900px) and (hover: hover) and (pointer: fine)').matches;
  });

  useEffect(() => {
    if (Platform.OS !== 'web') return;
    const media = window.matchMedia('(min-width: 900px) and (hover: hover) and (pointer: fine)');
    const update = () => setVisible(media.matches);
    update();
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);

  return visible;
}

export default function DesktopNotice({ visible }: { visible: boolean }) {
  const { t } = useTranslation();

  if (!visible) return null;

  return (
    <View style={styles.screen} testID="desktop-mobile-notice">
      <View style={styles.notice}>
        <View style={styles.copy}>
          <Text style={styles.title}>{t('web.desktopTitle')}</Text>
          <Text style={styles.body}>{t('web.desktopMessage')}</Text>
        </View>
        <Image
          source={require('../assets/images/desktop-qr.png')}
          style={styles.qr}
          accessibilityLabel={t('web.desktopQrLabel')}
        />
        <Text selectable style={styles.address}>{WEB_APP_HOST}</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 32,
    backgroundColor: '#FBEFE3',
  },
  notice: {
    width: '100%',
    maxWidth: 420,
    alignItems: 'center',
    gap: 24,
    paddingHorizontal: 40,
    paddingVertical: 40,
    borderRadius: 16,
    backgroundColor: '#FFF',
  },
  copy: {
    alignItems: 'center',
    gap: 8,
  },
  title: {
    fontFamily: 'Inter_700Bold',
    fontSize: 20,
    lineHeight: 26,
    color: '#1C453F',
    textAlign: 'center',
  },
  body: {
    fontFamily: 'Inter_400Regular',
    fontSize: 15,
    lineHeight: 22,
    color: '#1C453F',
    textAlign: 'center',
  },
  qr: {
    width: 220,
    height: 220,
  },
  address: {
    fontFamily: 'Inter_600SemiBold',
    fontSize: 16,
    color: '#1C453F',
  },
});
